import React from 'react';
import { type MixedSchema } from 'yup';
import { type LeafError } from '../form/errors/LeafError.tsx';

export interface IFormItemContext {
  ariaLabelId?: string;
  errors?: LeafError[];
  warnings?: string[];
  required?: boolean;
  enabled?: boolean;
  layoutEnabled?: boolean;
  visuallyDisabled?: boolean;
  /** Funzione on-demand per ottenere lo schema risolto. Non è stato reattivo. */
  getSchema?: (index?: number) => MixedSchema | null;
  readonly?: boolean;
  name?: Array<string | undefined>;
  setLabelAddition?: (labelAddition: React.ReactNode | undefined) => void;
}

/**
 * Contesto accessibile ai singoli Input contenente informazioni sullo
 * stato di validazione del campo e sullo schema di validazione a cui è
 * collegato.
 * È possibile utilizzare questo contesto per aggiungere informazioni
 * necessarie all'accessibilità o anche per altri usi.
 */
export const FormItemContext = React.createContext<IFormItemContext>({});

export function useFormItemContext() {
  return React.useContext(FormItemContext);
}
